import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const AlertsMainContainer = styled(Box)(() => ({
  position: "fixed",
  bottom: 20,
  right: "calc(50% - 150px)",
  zIndex: 1000,
}));

export const AlertContainer = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[800] : theme.palette.grey[100],
  fontWeight: 300,
  display: "flex",
  alignItems: "center",
  height: 48,
  borderRadius: theme.shape.borderRadius,
  minWidth: 300,
  width: "fit-content",
  justifyContent: "space-between",
  marginTop: theme.spacing(1.25),
  position: "relative",
}));

export const Message = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(2.5),
  marginRight: theme.spacing(1.875),
}));

export const StatusColor = styled(Box)(({ theme }) => ({
  height: "100%",
  width: 5,
  borderTopLeftRadius: theme.shape.borderRadius,
  borderBottomLeftRadius: theme.shape.borderRadius,
  position: "absolute",
  left: 0,
  "&.alert-success": {
    backgroundColor: theme.palette.success.main,
  },
  "&.alert-error": {
    backgroundColor: theme.palette.error.main,
  },
  "&.alert-warning": {
    backgroundColor: theme.palette.warning.main,
  },
  "&.alert-info": {
    backgroundColor: theme.palette.info.main,
  },
}));
